import React, { Component } from 'react';
import { I18n } from 'react-i18next';

export default class IntroduceCoin extends Component {
    render () {
        return (
            <I18n>
                {
                    (t, { i18n }) => (
                        <div className="section" id="section11">
                            <div className="s10-bg">
                                <div className="container">
                                    <div className="row">
                                        <h2 className="partner-title">Official Partners</h2>
                                    </div>
                                    <br/>
                                    <div className="row partner-wrap">
                                        <div className="col-md-4 col-xs-6 text-center partner-block">
                                            <a href={'https://tee-coin.com/'} target={'_blank'}>
                                                <img src={'/images/tee_coin.png'} className="partner-icon" alt={'tee'}/>
                                            </a>
                                        </div>
                                        <div className="col-md-4 col-xs-6 text-center partner-block">
                                            <a href={'https://www.kex.com'} target={'_blank'}>
                                                <img src={'/images/kex_coin.png'} className="partner-icon" alt={'kex'}/>
                                            </a>
                                        </div>
                                        <div className="col-md-4 col-xs-6 text-center partner-block">
                                            <a href={'https://www.exxvip.com'} target={'_blank'}>
                                                <img src={'/images/exx_coin.png'} className="partner-icon" alt={'kex'}/>
                                            </a>
                                        </div>
                                        <div className="col-md-4 col-xs-6 text-center partner-block">
                                            <a href={'https://www.biki.com'} target={'_blank'}>
                                                <img src={'/images/biki_coin.png'} className="partner-icon" alt={'kex'}/>
                                            </a>
                                        </div>
                                        <div className="col-md-4 col-xs-6 text-center partner-block">
                                            <a href={'https://head-2-head.net/'} target={'_blank'}>
                                                <img src={'/images/head2head.png'} className="partner-icon" altpartner-block={'kex'} alt={'head2head'}/>
                                            </a>
                                        </div>
                                        <div className="col-md-4 col-xs-6 text-center partner-block">
                                            <a href={'https://exchange-sgp.com/'} target={'_blank'}>
                                                <img src={'/images/exchange_sgp2.png'} className="partner-icon" alt={'exchange'}/>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                }
            </I18n>
        )
    }
}



// WEBPACK FOOTER //
// ./src/containers/introduce-coin.jsx